module.exports = __webpack_public_path__ + "static/logo-dark-0025dc478b03ebd1a6c23cb1c63bda46.svg";